import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RiArrowDownSLine } from "react-icons/ri";
import { toast } from 'react-toastify';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { motion } from "framer-motion";

const RestUserAdd = () => {

  const navigate = useNavigate();
  const { rest_slug2 } = useParams();

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [mobile_phone, setMobilePhone] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [role, setRole] = useState([]);
  const [errors, setErrors] = useState({});

  const [showOption, setShowOption] = useState({ stato: false, role: false });

  const states = ["Active", "Inactive"];
  // const roles = ["Venditore", "Super Admin", "Cliente Horeca", "Cliente Finale"];

  // Animation UX: Field animation
  const fieldVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, delay: i * 0.1 }
    })
  };

  // Animation UX: Dropdown option animation
  const optionVariants = {
    hidden: { opacity: 0, y: -5 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.2, delay: i * 0.05 }
    })
  };

  // Animation UX: Button animation
  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.2 } }
  };

  const generateRandomPassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialChars = "!@#$%&*";

    // Ensure at least one of each required character
    let password =
      uppercase[Math.floor(Math.random() * uppercase.length)] + // At least one uppercase
      specialChars[Math.floor(Math.random() * specialChars.length)] + // At least one special character
      numbers[Math.floor(Math.random() * numbers.length)] + // At least one number
      lowercase[Math.floor(Math.random() * lowercase.length)]; // At least one lowercase

    const allCharacters = uppercase + lowercase + numbers + specialChars;

    // Fill the rest of the password with random characters
    for (let i = 4; i < 6; i++) {
      password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
    }

    // Shuffle the password to mix the required characters
    return password
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");
  };

  const handleInputClick = () => {
    if (!password || password.trim().length === 0) {
      const newPassword = generateRandomPassword();
      setPassword(newPassword);
      if (errors.password) {
        setErrors((prev) => ({ ...prev, password: "" }));
      }
    }
  };

  const getRoleData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/roles`,
        {
          params: {
            type: "restaurant",
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRole(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching user role data:", error);
    }
  };

  const toggleDropdown = (dropdownName) => {
    setShowOption({
      stato: dropdownName === "stato" ? !showOption.stato : false,
      role: dropdownName === "role" ? !showOption.role : false,
    });
  };

  const handleStateSelect = (stato) => {
    setSelectedState(stato);
    setShowOption({ stato: false });
    if (errors.status) setErrors((prev) => ({ ...prev, status: "" }));
  };

  const handleRoleSelect = (selectedRole) => {
    setSelectedRole(selectedRole);
    setShowOption({ role: false });
    if (errors.role) setErrors((prev) => ({ ...prev, role: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name || !name.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!surname || !surname.trim()) {
      newErrors.surname = "Surname is required.";
    }
    if (!email || !email.trim()) {
      newErrors.email = "Email is required.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        newErrors.email = "Please enter a valid email address.";
      }
    }
    if (!password || !password.trim()) {
      newErrors.password = "Password is required.";
    }
    if (!mobile_phone || !mobile_phone.trim()) {
      newErrors.mobile_phone = "Mobile phone is required.";
    }
    if (!selectedState) {
      newErrors.status = "Status is required.";
    }
    if (!selectedRole || !selectedRole?.id) {
      newErrors.role = "Role is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        name,
        surname,
        email,
        password,
        mobile_phone,
        status: selectedState,
        role_id: selectedRole?.id,
      };

      const response = await axios.post(
        `${apiUrl}/api/v1/restaurants/${rest_slug2}/create-user`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        navigate(`/restaurantPanel/restaurant-user/${localStorage.getItem("currentRestId") ? localStorage.getItem("currentRestId") : 5231}`);
        toast.success(response?.data?.message || 'Restaurant user created successfully!', {
          theme: 'colored',
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error('Error creating user:', error?.response?.data || error);
      const apiErrors = error?.response?.data?.errors;
      let firstErrorMessage = '';
      if (apiErrors && typeof apiErrors === 'object') {
        const errorValues = Object.values(apiErrors).flat();
        if (errorValues.length > 0 && typeof errorValues[0] === 'string') {
          firstErrorMessage = errorValues[0];
        }
      }
      if (!firstErrorMessage) {
        firstErrorMessage = error?.response?.data?.message || 'Something went wrong. Please try again.';
      }
      toast.error(firstErrorMessage, {
        theme: 'colored',
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRoleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOption({ stato: false });
      }
    };
    document.addEventListener("click", handleClickOutsideClick);
    return () => {
      document.removeEventListener("click", handleClickOutsideClick);
    };
  }, []);

  return (
    <>
      <section className="border-t border-[#D9D9D9] mt-5 pt-10">
        <motion.h3
          className="text-2xl font-bold mb-2 poppins-medium"
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
        >
          Aggiungi Utente
        </motion.h3>
        <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5bg-[#f6efef] border-[2px] border-[#8B24332B] md:p-10 p-4 rounded-xl shadow-md font-sans">
          <div className="flex flex-col space-y-4 mb-4">
            <div className="flex gap-3 md:flex-row flex-col">
              <motion.div
                className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={0}
              >
                <div className="flex items-center h-[26px]">
                  <label className="text-sm font-semibold poppins-medium text-[#404040]">
                    Nome:
                  </label>
                </div>
                <input
                  type="text"
                  className={`h-[42px] poppins-regular px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border ${errors.name ? "border-red-500" : "border-gray-300"} focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]`}
                  value={name?.replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, " ") || ""}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (errors.name) setErrors((prev) => ({ ...prev, name: "" }));
                  }}
                  placeholder="inserisci il tuo nome"
                />
                {errors.name && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.name}</span>
                )}
              </motion.div>
              <motion.div
                className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={1}
              >
                <div className="flex items-center h-[26px]">
                  <label className="text-sm font-semibold poppins-medium text-[#404040]">
                    Cognome:
                  </label>
                </div>
                <input
                  type="text"
                  className={`h-[42px] poppins-regular px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border ${errors.surname ? "border-red-500" : "border-gray-300"} focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]`}
                  value={surname?.replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, " ") || ""}
                  onChange={(e) => {
                    setSurname(e.target.value);
                    if (errors.surname) setErrors((prev) => ({ ...prev, surname: "" }));
                  }}
                  placeholder="inserisci il tuo cognome"
                />
                {errors.surname && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.surname}</span>
                )}
              </motion.div>
            </div>
            <div className="flex gap-3 md:flex-row flex-col">
              <motion.div
                className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={2}
              >
                <div className="flex items-center h-[26px]">
                  <label className="text-sm font-semibold poppins-medium text-[#404040]">
                    Email:
                  </label>
                </div>
                <input
                  type="email"
                  className={`h-[42px] poppins-regular px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border ${errors.email ? "border-red-500" : "border-gray-300"} focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]`}
                  value={email || ""}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (errors.email) setErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  placeholder="inserisci la tua email"
                />
                {errors.email && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.email}</span>
                )}
              </motion.div>
              <div className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3">
                <motion.div
                  className="flex items-center gap-3 h-[26px]"
                  variants={fieldVariants}
                  initial="hidden"
                  animate="visible"
                  custom={3}
                >
                  <label htmlFor="password" className="password-label text-sm font-semibold poppins-medium text-[#404040]">
                    Password:
                  </label>
                  <button
                    type="button"
                    className="generate-password-button poppins-regular px-3 h-[24px] flex items-center justify-center text-xs text-[#8A2533] bg-[#FCFCFC] border border-[#d18d97] rounded-full hover:bg-[#8A2533] hover:text-white transition-all duration-200 shadow-sm focus:outline-none cursor-pointer whitespace-nowrap shrink-0"
                    onClick={handleInputClick}
                  >
                    Genera Password
                  </button>
                </motion.div>
                <div className="relative w-full">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="new-password"
                    className={`h-[42px] w-full poppins-regular pl-4 pr-11 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border ${errors.password ? "border-red-500" : "border-gray-300"} focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]`}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      if (errors.password) setErrors((prev) => ({ ...prev, password: "" }));
                    }}
                    placeholder="inserisci la tua password"
                  />
                  <button
                    type="button"
                    className="absolute top-1/2 right-4 -translate-y-1/2 text-gray-400 hover:text-[#8A2533] focus:outline-none transition-colors cursor-pointer flex items-center justify-center"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                    aria-label={showPassword ? "Nascondi password" : "Mostra password"}
                  >
                    {showPassword ? <FaRegEyeSlash size={16} /> : <FaRegEye size={16} />}
                  </button>
                </div>
                {errors.password && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.password}</span>
                )}
              </div>
            </div>
            <div className="flex gap-3 md:flex-row flex-col">
              <motion.div
                className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={4}
              >
                <div className="flex items-center h-[26px]">
                  <label className="text-sm font-semibold poppins-medium text-[#404040]">
                    Stato:
                  </label>
                </div>
                <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                  <div className={`border ${errors.status ? "border-red-500" : "border-gray-300"} rounded-3xl`}>
                    <button
                      className="h-[40px] inline-flex justify-between items-center w-full px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                      onClick={() => toggleDropdown("stato")}
                    >
                      <span className="mr-2 flex items-center gap-3 poppins-medium">
                        {selectedState === "Active" ? "Attivo" : selectedState === "Inactive" ? "Inattivo" : "Scegli stato"}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.stato ? "rotate-180" : ""}`}
                        size={"20px"}
                        color="#9f414f"
                      />
                    </button>
                    <motion.div
                      className={`${showOption.stato ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"} bg-transparent absolute top-0 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: showOption.stato ? 1 : 0, y: showOption.stato ? 0 : -10 }}
                      transition={{ duration: 0.2 }}
                    >
                      {states
                        .filter((states) => states !== selectedState)
                        .map((states, index, array) => (
                          <motion.label
                            key={states}
                            className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                            onClick={() => handleStateSelect(states)}
                            variants={optionVariants}
                            initial="hidden"
                            animate="visible"
                            custom={index}
                          >
                            <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                              {states === "Active" ? "Attivo" : states === "Inactive" ? "Inattivo" : ""}
                            </span>
                          </motion.label>
                        ))}
                    </motion.div>
                  </div>
                </div>
                {errors.status && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.status}</span>
                )}
              </motion.div>
              <motion.div
                className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
                variants={fieldVariants}
                initial="hidden"
                animate="visible"
                custom={3}
              >
                <div className="flex items-center h-[26px]">
                  <label className="text-sm font-semibold poppins-medium text-[#404040]">
                    Numero di cellulare:
                  </label>
                </div>
                <input
                  type="text"
                  className={`h-[42px] poppins-regular px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border ${errors.mobile_phone ? "border-red-500" : "border-gray-300"} focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]`}
                  value={mobile_phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setMobilePhone(value);
                      if (errors.mobile_phone) setErrors((prev) => ({ ...prev, mobile_phone: "" }));
                    }
                  }}
                  placeholder="inserisci il tuo numero di cellulare"
                />
                {errors.mobile_phone && (
                  <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.mobile_phone}</span>
                )}
              </motion.div>
            </div>
          </div>
          <div className="flex gap-3 md:flex-row flex-col">
            <motion.div
              className="flex flex-col md:w-[calc(50%-6px)] w-full gap-3"
              variants={fieldVariants}
              initial="hidden"
              animate="visible"
              custom={5}
            >
              <div className="flex items-center h-[26px]">
                <label className="text-sm font-semibold poppins-medium text-[#404040]">
                  Ruolo:
                </label>
              </div>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                <div className={`border ${errors.role ? "border-red-500" : "border-gray-300"} rounded-3xl`}>
                  <button
                    className="h-[40px] inline-flex justify-between items-center w-full px-4 text-xs text-[#8B8B8B] rounded-3xl bg-transparent focus:outline-none relative z-10"
                    onClick={() => toggleDropdown("role")}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {selectedRole?.name === "Operator" ? "Operatore" : selectedRole?.name || "Scegli ruolo"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${showOption.role ? "rotate-180" : ""}`}
                      size={"20px"}
                      color="#9f414f"
                    />
                  </button>
                  <motion.div
                    className={`${showOption.role ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"} bg-transparent absolute top-0 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: showOption.role ? 1 : 0, y: showOption.role ? 0 : -10 }}
                    transition={{ duration: 0.2 }}
                  >
                    {(Array.isArray(role) ? role : Object.values(role || {}))
                      .filter((r) => (selectedRole?.id ? String(r?.id) !== String(selectedRole?.id) : true))
                      .map((r, index, array) => (
                        <motion.label
                          key={r?.id || index}
                          className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                          onClick={() => handleRoleSelect(r)}
                          variants={optionVariants}
                          initial="hidden"
                          animate="visible"
                          custom={index}
                        >
                          <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                            {r?.name === "Operator" ? "Operatore" : r?.name}
                          </span>
                        </motion.label>
                      ))}
                  </motion.div>
                </div>
              </div>
              {errors.role && (
                <span className="text-xs text-red-500 poppins-regular pl-2 -mt-1">{errors.role}</span>
              )}
            </motion.div>
          </div>

          <div className="flex sm:flex-row flex-col text-sm justify-start gap-4 mt-4">
            {isLoading ? (
              <motion.button
                disabled
                type="button"
                className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group"
                variants={buttonVariants}
                initial="hidden"
                animate="visible"
              >
                <motion.svg
                  aria-hidden="true"
                  className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </motion.svg>
                Loading...
              </motion.button>
            ) : (
              <motion.button
                className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                onClick={handleSave}
                variants={buttonVariants}
                initial="hidden"
                animate="visible"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <TiTick size={"25px"} color="green" />
                <span className="poppins-regular">Salva</span>
              </motion.button>
            )}
            <motion.button
              className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={() => navigate(`/restaurantPanel/restaurant-user/${localStorage.getItem("currentRestId")}`)}
              variants={buttonVariants}
              initial="hidden"
              animate="visible"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <IoClose size={"25px"} color="red" className="group-hover:invert" />
              <span className="poppins-regular">Annulla</span>
            </motion.button>
          </div>
        </div>
      </section>
    </>
  );
};
export default RestUserAdd;
